// 必要なフィールドだけを動的に取得する関数
export const getFields = (fields, fieldsToInclude) => {
    return fields.filter(field => fieldsToInclude.includes(field.name));
};

// 検索フィールド定義
export const searchFields = [
    /* orders */
    {
        name: 'dates',
        type: 'date',
        label: '期間指定',
    },
    {
        name: 'order_numbers',
        type: 'textarea',
        label: '注文番号',
        placeholder: '改行で複数検索できます',
    },
    /* clients */
    {
        name: 'is_pending',
        type: 'checkbox',
        label: '申請中を表示する',
    },
    {
        name: 'client_code',
        type: 'text',
        label: '取引先コード',
    },
    {
        name: 'client_name',
        type: 'text',
        label: '会社名',
    },
    /* inventory */
    {
        name: 'product_code',
        type: 'textarea',
        label: '商品コード',
    },
    {
        name: 'product_name',
        type: 'text',
        label: '商品名',
    },
    {
        name: 'category_id',
        type: 'select',
        label: 'カテゴリー',
    },
    {
        name: 'is_baseline_stock',
        type: 'checkbox',
        label: '基準在庫以下',
    },
    {
        name: 'is_min_stock_level',
        type: 'checkbox',
        label: '最低在庫以下',
    },
    {
        name: 'category',
        type: 'category',
    },
];

export const clientFields = [
    {
        label: '顧客名',
        name: 'client_name',
        type: 'text',
        placeholder: '株式会社〇〇',
        inputProps: { maxLength: 100 },
        validation: {
            required: '顧客名は必須です',
            maxLength: { value: 100, message: '100文字以内で入力してください' },
        },
    },
    {
        label: '営業所名',
        name: 'branch_name',
        type: 'text',
        placeholder: '東京営業所（ない場合は-を入力）',
        inputProps: { maxLength: 100 },
        validation: {
            required: '営業所名は必須です',
            maxLength: { value: 100, message: '100文字以内で入力してください' },
        },
    },
    {
        label: '郵便番号',
        name: 'postal_code',
        type: 'text',
        placeholder: '1234567',
        inputProps: { maxLength: 8 },
        validation: {
            required: '郵便番号は必須です',
            pattern: { value: /^\d{3}\d{4}$/, message: '郵便番号はXXXXXXX形式で入力してください' },
        },
    },
    {
        label: '電話番号',
        name: 'client_phone',
        type: 'tel',
        placeholder: '03-1234-5678',
        inputProps: { maxLength: 20 },
        validation: {
            required: '電話番号は必須です',
            pattern: { value: /^(?:\+?\d{1,4}[-\s]?)?0?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{4}$/, message: '電話番号の形式が正しくありません' },
        },
    },
    {
        label: 'FAX番号',
        name: 'client_fax',
        type: 'tel',
        placeholder: '03-1234-5679',
        inputProps: { maxLength: 20 },
        validation: {
            pattern: { value: /^(?:\+?\d{1,4}[-\s]?)?0?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{4}$/, message: 'FAX番号の形式が正しくありません' },
        },
    },
    {
        label: '業種',
        name: 'industry_id',
        type: 'select',
        placeholder: '業種を選択してください',
        validation: { required: '業種は必須です' },
    },
    {
        label: '事業内容',
        name: 'business_description',
        type: 'textarea',
        placeholder: '事業内容を入力してください',
        inputProps: { maxLength: 2000 },
        validation: { maxLength: { value: 2000, message: '500文字以内で入力してください' } },
    },
    {
        label: 'WebサイトURL',
        name: 'website_url',
        type: 'url',
        placeholder: 'https://example.com',
        inputProps: { maxLength: 255 },
        validation: {
            pattern: { value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/, message: 'URL形式が正しくありません' },
            maxLength: { value: 255, message: '255文字以内で入力してください' },
        },
    },
];

export const contactFields = [
    {
        label: '担当者名',
        name: 'client_contact_name',
        type: 'text',
        placeholder: '山田 太郎',
        inputProps: { maxLength: 100 },
        validation: {
            required: '担当者名は必須です',
            maxLength: { value: 100, message: '100文字以内で入力してください' },
        },
    },
    {
        label: 'メールアドレス',
        name: 'client_contact_email',
        type: 'email',
        placeholder: 'taro@example.com',
        inputProps: { maxLength: 255 },
        validation: {
            required: 'メールアドレスは必須です',
            pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'メールアドレスの形式が正しくありません',
            },
            maxLength: { value: 255, message: '255文字以内で入力してください' },
        },
    },
    {
        label: '電話番号',
        name: 'client_contact_phone',
        type: 'tel',
        placeholder: '090-1234-5678',
        inputProps: { maxLength: 20 },
        validation: {
            required: '電話番号は必須です',
            pattern: {
                value: /^(?:\+?\d{1,4}[-\s]?)?0?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{4}$/,
                message: '電話番号の形式が正しくありません',
            },
        },
    },
];